var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTeva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .164h15.426v23.75H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00567A",
    d: "M63.661 14.51c0 2.482-1.886 4.93-4.778 4.93-2.77 0-4.777-2.13-4.777-4.93 0-3.105 2.291-4.949 4.719-4.949 3.013 0 4.836 2.467 4.836 4.95m-.363-8.762v1.005c-1.455-1.172-3.26-1.79-5.227-1.79-4.981 0-8.883 4.193-8.882 9.546 0 2.39.82 4.667 2.312 6.414 1.649 1.938 4.202 3.095 6.83 3.095 1.883 0 3.554-.601 4.967-1.787v1.002c0 .226.181.41.405.41h3.922a.408.408 0 0 0 .405-.41V5.749a.408.408 0 0 0-.405-.41h-3.922a.408.408 0 0 0-.405.41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.158 .076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00567A",
    d: "M11.208 19.504c-1.1 0-1.886-.34-2.416-1.004-.397-.498-.583-1.165-.583-2.261V9.486h5.068a.389.389 0 0 0 .387-.391v-3.47a.389.389 0 0 0-.387-.391H8.21V.574a.407.407 0 0 0-.405-.41H3.697a.407.407 0 0 0-.405.41v4.66H.405a.408.408 0 0 0-.405.41v3.433c0 .226.182.41.405.41h2.887v6.307c0 2.577.402 4.214 1.345 5.473 1.284 1.732 3.454 2.647 6.274 2.647 2.173 0 3.562-.52 4.311-1.114.216-.172.26-.558.133-.741a426.14 426.14 0 0 1-1.78-2.831c-.151-.248-.473-.305-.743-.156-.366.202-1.065.432-1.624.432",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00567A",
    d: "M23.332 8.968c1.54 0 3.31 1.184 3.514 3.1h-7.324c.232-1.5 1.739-3.1 3.81-3.1m0-4.034c-2.526 0-4.806 1.017-6.42 2.864-1.54 1.762-2.388 4.135-2.388 6.682 0 5.6 3.896 9.51 9.476 9.51 2.453 0 4.868-.902 6.571-2.407.076-.068.166-.154.258-.248a.412.412 0 0 0 .038-.536l-1.946-2.593a.401.401 0 0 0-.6-.05c-.112.108-.246.23-.386.346-.805.658-2.109 1.453-3.824 1.453-2.564 0-4.536-1.735-4.814-4.227h11.964a.58.58 0 0 0 .576-.524 9.2 9.2 0 0 0 .043-.911c0-2.507-.852-4.847-2.398-6.589a8.122 8.122 0 0 0-6.15-2.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A03B",
    d: "M40.817 19.3l.008-2.616c.002-1.067.223-2.258.633-3.473.465-1.383 1.134-2.559 1.874-3.414l1.13-1.464v6.118l-3.645 4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFCB37",
    d: "M44.462 8.333l2.4-3.11a.68.68 0 0 1 .798-.23.769.769 0 0 1 .475.731l-.018 3.864-3.655 4.863V8.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C7E79",
    d: "M48.117 9.588l-.01 2.22c.037 1.14-.152 2.452-.6 3.781-.41 1.216-.944 2.283-1.578 3.102L44.462 20.6v-6.148l3.655-4.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00567A",
    d: "M44.463 14.45v6.15l-2.383 3.1a.682.682 0 0 1-.8.231.77.77 0 0 1-.474-.732l.012-3.899 3.645-4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A03B",
    d: "M40.3 19.3l-.007-2.616c-.002-1.067-.223-2.258-.632-3.473-.466-1.383-1.134-2.559-1.875-3.414l-1.13-1.464v6.118L40.3 19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFCB37",
    d: "M36.656 8.333l-2.4-3.11a.68.68 0 0 0-.799-.23.77.77 0 0 0-.474.731L33 9.588l3.655 4.863V8.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C7E79",
    d: "M33.001 9.588l.01 2.22c-.037 1.14.152 2.451.6 3.782.41 1.215.945 2.283 1.578 3.101l1.467 1.908v-6.148L33 9.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00567A",
    d: "M36.656 14.45v6.15l2.383 3.1a.682.682 0 0 0 .8.231.77.77 0 0 0 .474-.732L40.3 19.3l-3.645-4.85z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTeva);
export default __webpack_public_path__ + "static/media/logo_teva.ae2bb2b4a886b9d7f8abc2531cc1ee4f.svg";
export { ForwardRef as ReactComponent };